import { render } from "./lastOrders.vue?vue&type=template&id=d986489e&scoped=true&lang=html"
import script from "./lastOrders.vue?vue&type=script&lang=js"
export * from "./lastOrders.vue?vue&type=script&lang=js"

import "./lastOrders.vue?vue&type=style&index=0&id=d986489e&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d986489e"]])

export default __exports__